// extracted by mini-css-extract-plugin
export var columnList = "_fo-0";